import React from "react";
import "./Header.css"


const Header = () =>{
    return(
    <>
    <>
  {/* START SLIDER */}
  <div
    id="slider-carousel"
    className="carousel slide carousel-fade"
    data-ride="carousel"
    data-interval={7000}
  >
    <ol className="carousel-indicators">
      <li data-target="#slider-carousel" data-slide-to={0} className="active" />
      <li data-target="#slider-carousel" data-slide-to={1} />
      <li data-target="#slider-carousel" data-slide-to={2} />
    </ol>
    <div className="carousel-inner" role="listbox">
      {/* Slider 1 */}
      <div
        className="carousel-item active"
        style={{ backgroundImage: 'url("assets/images/hero.jpg")' }}
      >
        <div className="carousel-caption">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="animated fadeInDown">
                Transform Your Celebrations{" "}
                  <span className="theme-text-default2">with Exquisite Event </span>{" "}
                  Planning
                </h1>
                <p className="animated fadeIn">
                A blend of professionalism, creativity, and passion, conveying the planner's 
                dedication to crafting exceptional events that leave a lasting impression.
                </p>
                <div className="slider-btn animated fadeInUp">
                  <a href="#lu" className="btn theme-btn-default btn-icon">
                    <span>Read More</span>
                  </a>
                  <a href="#lu" className="btn theme-btn-default-two btn-icon">
                    <span>Get Start</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Slider 2 */}
      <div
        className="carousel-item"
        style={{ backgroundImage: 'url("assets/images/pies.jpg")' }}
      >
        <div className="carousel-caption">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="animated fadeInDown">
                Transform Your Celebrations{" "}
                  <span className="theme-text-default">with Exquisite Food </span>{" "}
                  Catering
                </h1>
                <p className="animated fadeIn">
                Embark on a culinary adventure with our team of expert chefs, 
                crafting unforgettable dining experiences that tantalize the taste buds.
                </p>
                <div className="slider-btn animated fadeInUp">
                  <a href="#lu" className="btn theme-btn-default btn-icon">
                    <span>Read More</span>
                  </a>
                  <a href="#lu" className="btn theme-btn-default-two btn-icon">
                    <span>Get Start</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Slider 3 */}
      <div
        className="carousel-item"
        style={{ backgroundImage: 'url("assets/images/logistics.jpg")' }}
      >
        <div className="carousel-caption">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="animated fadeInDown">
                Your Logistics Partner{" "}
                  <span className="theme-text-default"> for Seamless Supply Chain </span>{" "}
                  Management
                </h1>
                <p className="animated fadeIn">
                We deliver efficiency, cost-effectiveness, and reliability to brands, individuals and businesses of all sizes.
                </p>
                <div className="slider-btn animated fadeInUp">
                  <a href="#lu" className="btn theme-btn-default btn-icon">
                    <span>Explore More</span>
                  </a>
                  <a href="#lu" className="btn theme-btn-default-two btn-icon">
                    <span>Get Start</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Slider 4 */}
      <div
        className="carousel-item"
        style={{ backgroundImage: 'url("assets/images/car.jpg")' }}
      >
        <div className="carousel-caption">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="animated fadeInDown">
                Your One-Stop Shop {" "}
                  <span className="theme-text-default"> for High-Quality Car </span>{" "}
                  Auto Parts
                </h1>
                <p className="animated fadeIn">
                We provide the widest selection of auto parts at the most competitive prices.
                </p>
                <div className="slider-btn animated fadeInUp">
                  <a href="#lu" className="btn theme-btn-default btn-icon">
                    <span>Explor More</span>
                  </a>
                  <a href="#lu" className="btn theme-btn-default-two btn-icon">
                    <span>Get Start</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Slider 5 */}
      <div
        className="carousel-item"
        style={{ backgroundImage: 'url("assets/images/insurance.webp")' }}
      >
        <div className="carousel-caption">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="animated fadeInDown">
                Protect Your Future {" "}
                  <span className="theme-text-default">with Comprehensive Insurance </span>{" "}
                  Solutions
                </h1>
                <p className="animated fadeIn">
                We understand that life is full of unexpected twists and turns. That's why 
                we're dedicated to providing you with the comprehensive insurance coverage you 
                need to safeguard your future and protect what matters most.
                </p>
                <div className="slider-btn animated fadeInUp">
                  <a href="#lu" className="btn theme-btn-default btn-icon">
                    <span>Explore More</span>
                  </a>
                  <a href="#lu" className="btn theme-btn-default-two btn-icon">
                    <span>Get Start</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="slider-after" />
    {/* Previous Btn */}
    <a
      className="carousel-control-prev"
      href="#slider-carousel"
      role="button"
      data-slide="prev"
    >
      <span className="carousel-control-prev-icon" aria-hidden="true" />
      <span className="sr-only">Previous</span>
    </a>
    {/* Next Btn */}
    <a
      className="carousel-control-next"
      href="#slider-carousel"
      role="button"
      data-slide="next"
    >
      <span className="carousel-control-next-icon" aria-hidden="true" />
      <span className="sr-only">Next</span>
    </a>
  </div>
  {/* END SLIDER */}
</>

    </>
    )
}
export default Header;